import { ChannelkartNetworkGet, ChannelkartNetworkPost } from "../networkService";


export async function uploadFile(formData: FormData){
    try {
        let url = "/v1/uploadFile/mdmuploads";
        const response = await ChannelkartNetworkPost(url, formData,{"Content-Type": "multipart/form-data"});
        return response.data.features;
    }
    catch(err:any){
        return(err.message);
    }
}




export async function translationUpload(blobData:FormData, fileToBeUploaded:any){
    try{
        const uploadedFile = await uploadFile(blobData);
        const uri = uploadedFile[0].Uri;
        const url = processFile(fileToBeUploaded);
        const transformer =[
            {
                "entityName": "TranslationInfo",
                "transformerId": "mdm_translation_info"
            }
        ]
        let dataObj = {} as any;
        dataObj['attributes']={
            entityName: "TranslationInfo",
            lob: localStorage.getItem("lob"),
            transformerInfo : transformer,
            filePath:uri
        }
        const response = await ChannelkartNetworkPost(url, dataObj);
        return response;
    }
    catch(error:any){
        return(error.message);
    }
}

export function processFile(file:any){
    const filetype: string = file.name.split(".").pop();
    let url;

    if (filetype === "zip")
		url = "/tasks/types/blobcreater/execute";
	else if (filetype === "excel")
		url = "/tasks/types/mdmupload/execute";
	else
		url = "/tasks/types/mdmupload/execute";

    return url;
}

export async function checkReportStatus(id : string){
    try {
    const response = await ChannelkartNetworkGet(`/tasks/${id}`);
      return response;
    } catch (error) {
        return error;
    }
}
export function changeKeyToSnakeCase(key: string){
    
    key = key?.replace(/[^\w\s]/g, '');
    key = key?.trim();
    key = key?.replace(/\s+/g, '_');
    
    key = key?.toLowerCase();

    return key;
  };